import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import axios from 'axios';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const generateManifestPDF = async (orderId) => {
  const accessToken = localStorage.getItem('accessToken');
   const site_name = localStorage.getItem("site_name");
  const formData = new FormData();
  formData.set('orderId', orderId);
  const apiUrl = `${config.API_URL}/ws-proforma-invoice`;

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    const data = response.data;
    console.log(data);
    
    if (!data.success || !data.details.orderDetails || data.details.orderDetails.length === 0) {
      console.error("No order details found in the response.");
      return;  // Return early if order details are not available
    }

    const orderDetails = data.details.orderDetails[0];  // Get the first orderDetails object
    console.log(orderDetails);

    const totalSTDGoods = parseFloat(orderDetails.grand_total) - parseFloat(orderDetails.total_tax);
    const totalVAT = parseFloat(orderDetails.total_tax);
    const orderDiscount = parseFloat(orderDetails.order_discount);
    const totalAmount = parseFloat(orderDetails.grand_total);

    const doc = new jsPDF('landscape'); // Set to landscape orientation
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Margins
    const margin = 10;
    let y = margin;

    // Header sections
    const headerSections1 = [
      [
        { text: `{site_name}`, size: 13, bold: true },
        { text: 'Unit 6 Abenglen Industrial Estate,', size: 8, bold: false },
        { text: 'Betam Road, Hayes', size: 8, bold: false },
        { text: 'Middlesex, London UB3 1AT', size: 8, bold: false },
        { text: 'United Kingdom', size: 8, bold: false },
      ],
      [
        { text: 'Bank Details', size: 8, bold: true },
        { text: 'A/C No: GB994533184', size: 8, bold: false },
        { text: 'Sort Code : 44-208 329 3800', size: 8, bold: false },
      ]
    ];

    const headerSections3 = [
      [
        { text: `Collection Address: ${orderDetails.name}`, size: 8, bold: false },
        { text: `${orderDetails.address}`, size: 8, bold: false },
        { text: `${orderDetails.postal_code}`, size: 8, bold: false },
        { text: `${orderDetails.country}`, size: 8, bold: false },
      ],
      [
        { text: `Invoice No : ${orderDetails.reference_no}`, size: 8, bold: false },
        { text: `Order Date: ${orderDetails.date}`, size: 8, bold: false },
      ],
    ];

    const sectionWidth = (pageWidth - margin * 2) / 2; // Adjust for margins

    // Render header sections
    const renderSections = (sections) => {
      sections.forEach((section, index) => {
        const colStartX = margin + (index % 2) * sectionWidth;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 2); // Reduced space between lines
        });

        if (index % 4 === 3) {
          y += 12; // Reduced spacing after every 4 sections
        }
      });
      y += 15; // Add a little space after the last header section
    };

    renderSections(headerSections1);
    renderSections(headerSections3);

    // Render table
    const columns = [
      { title: 'Products', dataKey: 'product', size: 8, bold: false },
      { title: 'Order Type', dataKey: 'order_type', size: 8, bold: false },
      { title: 'Qty', dataKey: 'qty', size: 8, bold: false },
      { title: 'Unit Price', dataKey: 'unit_price', size: 8, bold: false },
      { title: 'Discount', dataKey: 'discount', size: 8, bold: false },
      { title: 'VAT', dataKey: 'vat', size: 8, bold: false },
      { title: 'Net Amount', dataKey: 'net_amount', size: 8, bold: false },
    ];

    const tableBody = data.details.product_details.map((item) => [
      item.product_code,
      item.order_type,
      item.order_qty,
      item.unit_price,
      item.is_promoted,
      item.item_tax,
      item.subtotal,
    ]);

    // Add an empty row with totals
    tableBody.push([
      '', '', '', '', 'Total:', totalSTDGoods.toFixed(2), totalVAT.toFixed(2),
    ]);

    // Render the table
    doc.autoTable({
      startY: y,
      head: [columns.map(col => col.title)],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: '#f8f9fa',
        textColor: '#404040',
        size: '13px',
      },
      margin: { top: 10 },
    });

    y = doc.autoTable.previous.finalY + 12; // Y position after table

    const addFooterSection = (footerSection) => {
      footerSection.forEach((section, index) => {
        const colStartX = margin + (index % 4) * sectionWidth;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 5);
        });

        if (index % 4 === 3) {
          y += 20; // Move down after every 4 sections
        }
      });
      y += 20; // Add space after each footer section
    };

    const addFooterWithSpaceCheck = (footerSection) => {
      const remainingSpace = pageHeight - y - margin; // Remaining space on the page
      const requiredSpace = footerSection.length * 5 + 20; // Space needed

      if (remainingSpace < requiredSpace) {
        doc.addPage(); // Add a new page if not enough space
        y = margin; // Reset Y position for new page
      }

      addFooterSection(footerSection);
    };

    const footerSections2 = [
      [
        { text: 'CHEP Standard', size: 8, bold: false },
        { text: 'LPR Standard', size: 8, bold: false },
        { text: 'IPP Standard', size: 8, bold: false },
        { text: 'CHEP Euro', size: 8, bold: false },
        { text: 'Others', size: 8, bold: false },
      ],
      [
        { text: 'Driver', size: 8, bold: false },
        { text: 'Loaded in good condition and correct pallet count', size: 8, bold: false },
        { text: 'Name -------------------------------', size: 8, bold: false },
        { text: 'Sign -------------------------------', size: 8, bold: false },
      ],
      [
        { text: 'Warehouse', size: 8, bold: false },
        { text: 'Visual inspection of pallets and product carried out', size: 8, bold: false },
        { text: 'Name -------------------------------', size: 8, bold: false },
        { text: 'Sign -------------------------------', size: 8, bold: false },
      ],
      [{ text: '', size: 8, bold: false }],
    ];

    const footerSections3 = [
      [
        { text: 'Subject to Star Pacific Limited terms and conditions of sale, a copy of which is available on request', size: 8, bold: false },
        { text: 'Star Pacific UK LTD (No. 7298396)', size: 8, bold: false },
        { text: 'Reservation of Title. The property in and the title to all goods sold by Star Pacific UK LTD shall not pass to the buyer until all monies due and owing have been paid in full', size: 8, bold: false },
      ]
    ];

    // Center footerSections3
    const centerFooter = (footerSection) => {
      footerSection.forEach((section) => {
        const centerX = (pageWidth - margin * 2) / 2; // Center position

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, centerX, y + i * 5, { align: 'center' }); // Center align text
        });

        y += 15; // Add space after each footer section
      });
    };

    // Add footer sections with space checks
    addFooterWithSpaceCheck(footerSections2);
    centerFooter(footerSections3); // Center the third footer

    const filename = generateUniqueFilename('Invoice', 'pdf');
    doc.save(filename);

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default generateManifestPDF;
